import { render, staticRenderFns } from "./ProductInfoExtra.vue?vue&type=template&id=7186fe5e"
import script from "./ProductInfoExtra.vue?vue&type=script&lang=ts"
export * from "./ProductInfoExtra.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7186fe5e')) {
      api.createRecord('7186fe5e', component.options)
    } else {
      api.reload('7186fe5e', component.options)
    }
    module.hot.accept("./ProductInfoExtra.vue?vue&type=template&id=7186fe5e", function () {
      api.rerender('7186fe5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/ProductInfoExtra.vue"
export default component.exports